import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { InfoLayout } from '@/components/info/InfoLayout';
import { SkeletonLoader } from '@/components/info/common/SkeletonLoader';
import { useWorkerInfo } from '@/hooks/useWorkerInfo';
import { colors, spacing } from '@/theme';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { ExpiredSessionScreen } from './ExpiredSessionScreen';

export function WorkerInfoPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const currentWorkerId = user?.id || '';

  const { loading, error, workerInfo, refresh } = useWorkerInfo(currentWorkerId);

  useEffect(() => {
    if (currentWorkerId) {
      refresh();
    }
  }, [currentWorkerId, refresh]);

  if (!currentWorkerId) {
    return null;
  }

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleRetry = () => {
    refresh();
  };

  if (loading) {
    return <SkeletonLoader />;
  }

  if (error) {
    return (
      <ExpiredSessionScreen />
    );
  }

  if (!workerInfo) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          color: colors.gray[600],
        }}
      >
        No se encontro informacion del trabajador
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <InfoLayout workerId={currentWorkerId} />
    </motion.div>
  );
}
